module.exports = __webpack_public_path__ + "img/星洛城广场.6c274169.jpg";